import {Enums} from './enums';

export class AssetsHelper {

  static categoryIconURL(category: string): string {

    const baseUrl = './assets/skill-icons/';

    switch (category) {

      case Enums.QuestionCategories.numberPatterns:
      case Enums.QuestionCategories.imagePatterns:

        return baseUrl + 'patterns.png';

      case Enums.QuestionCategories.shapes:

        return baseUrl + 'forms.png';

      case Enums.QuestionCategories.count:

        return baseUrl + 'count.png';

      case Enums.QuestionCategories.placeValue:

        return baseUrl + 'placeValue.png';

      case Enums.QuestionCategories.addition:

        return baseUrl + 'addition.png';

      case Enums.QuestionCategories.subtraction:

        return baseUrl + 'subtraction.png';

      case Enums.QuestionCategories.multiplication:

        return baseUrl + 'multiplication.png';

      case Enums.QuestionCategories.division:

        return baseUrl + 'division.png';

      case Enums.QuestionCategories.sizeComparison:

        return baseUrl + 'sizes.png';

      case Enums.QuestionCategories.fractions:

        return baseUrl + 'fractions.png';

      case Enums.QuestionCategories.transformations:

        return baseUrl + 'geometricTransformations.png';

      case Enums.QuestionCategories.rounding:

        return baseUrl + 'rounding.png';

      case Enums.QuestionCategories.dataRepresentation:

        return baseUrl + 'barChart.png';

      case Enums.QuestionCategories.area:

        return baseUrl + 'area.png';

      case Enums.QuestionCategories.perimeter:

        return baseUrl + 'perimeter.png';

      case Enums.QuestionCategories.lengthAndDistance:

        return baseUrl + 'measurement.png';

      default:

        return './assets/sidebar/questions-circular-gray.svg';
    }

  }


}
